import { CardBrand } from "../../types/payment";

// ---- Single brand icon component ----
export const BrandIcon = ({ brand }: { brand: CardBrand }) => {
  const commonProps = {
    width: 36,
    height: 24,
    style: {
      borderRadius: 4,
      background: "#fff",
      border: "1px solid #e0e0e0",
    },
  };

  const Label = ({ text }: { text: string }) => (
    <svg {...commonProps}>
      <rect x="0" y="0" width="100%" height="100%" fill="#fff" />
      <text
        x="50%"
        y="55%"
        dominantBaseline="middle"
        textAnchor="middle"
        fontSize="9"
        fontFamily="Inter, system-ui, Arial"
        fill="#111"
      >
        {text}
      </text>
    </svg>
  );

  switch (brand) {
    case "visa":
      return (
        <svg {...commonProps} viewBox="0 0 48 32">
          <rect x="0" y="0" width="48" height="32" fill="#fff" />
          <text
            x="24"
            y="18"
            textAnchor="middle"
            fontSize="12"
            fontWeight="700"
            fill="#1A1F71"
          >
            VISA
          </text>
        </svg>
      );
    case "mastercard":
      return (
        <svg {...commonProps} viewBox="0 0 48 32">
          <rect x="0" y="0" width="48" height="32" fill="#fff" />
          <circle cx="20" cy="16" r="8" fill="#EB001B" />
          <circle cx="28" cy="16" r="8" fill="#F79E1B" opacity="0.9" />
        </svg>
      );
    case "amex":
      return <Label text="AMEX" />;
    case "jcb":
      return <Label text="JCB" />;
    case "unionpay":
      return <Label text="UnionPay" />;
    default:
      return null;
  }
};
